import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Inject, Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { SessionStorageDataModel, SessionStorageService } from '@shared/services/session-storage/session-storage.service';
import * as SelectedOrderActions from './selected-order.actions';

@Injectable({
  providedIn: 'root',
})
export class SelectedOrderEffects {
  constructor(
    private actions$: Actions,
    @Inject(SessionStorageService) private _sessionStorage: SessionStorageService,
  ) {}

  selectedOrderEffect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SelectedOrderActions.setSelectedOrderData),
        tap((action: ReturnType<typeof SelectedOrderActions.setSelectedOrderData>) => {
          if (this._sessionStorage.storage) {
            this._sessionStorage.storage.SESSION_STORAGE = {
              ...(this._sessionStorage.storage.SESSION_STORAGE || {}),
              selectedOrderData: action.dossierNumber,
            } as SessionStorageDataModel;
          }
        }),
      ),
    { dispatch: false },
  );
}
